import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SearchResultGrid from "../new_home_page/trending_products/search-result-grid";
import classes from "./css/search-drawer.module.scss";

const SearchDrawer = ({
  show,
  onClose,
  search,
  onSearchChange,
  searchResults,
  isSearching,
  totalProducts,
}) => {
  const [trendingProducts, setTrendingProducts] = useState([]);
  const categories =
    (window.navLinksTop &&
      window.navLinksTop.navBar &&
      window.navLinksTop.navBar[0] &&
      window.navLinksTop.navBar[0].subCategoryCol0) ||
    [];

  useEffect(() => {
    if (window.trending_products) {
      setTrendingProducts(window.trending_products.slice(0, 10));
    }
  }, []);

  useEffect(() => {
    if (!show) return;
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      window.scrollTo(0, scrollY);
    };
  }, [show]);

  if (!show) return null;

  const hasSearchResults = search && searchResults && searchResults.length > 0;
  const displayProducts = hasSearchResults ? searchResults : trendingProducts;

  const handleClose = (e) => {
    if (e) e.stopPropagation();
    onClose();
  };

  const formatCategory = (name) => {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  return (
    <>
      <div className={classes.overlay} onClick={handleClose} />
      <div className={classes.drawer} onClick={(e) => e.stopPropagation()}>
        <button
          className={classes.closeBtn}
          onClick={handleClose}
          type="button"
          aria-label="Close search"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000000"
            strokeWidth="1.5"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className={classes.body}>
          <form action="/jewellery" className={classes.searchForm}>
            <input
              autoFocus
              type="text"
              placeholder="I'm looking for ..."
              maxLength="128"
              value={search || ""}
              name="query"
              className={classes.searchInput}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            {search && (
              <button
                type="button"
                className={classes.clearBtn}
                onClick={() => onSearchChange("")}
                aria-label="Clear search"
              >
                CLEAR
              </button>
            )}
            <svg
              className={classes.searchIcon}
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <circle cx="9" cy="9" r="6.5" stroke="#000000" strokeWidth="1" />
              <line
                x1="13.7"
                y1="13.7"
                x2="17.5"
                y2="17.5"
                stroke="#000000"
                strokeWidth="1"
              />
            </svg>
          </form>
          <div className={classes.categoriesSection}>
            <p className={classes.sectionTitle}>Popular Categories</p>
            <div className={classes.categories}>
              {categories.map((cat, index) => (
                <Link
                  key={index}
                  className={classes.categoryPill}
                  to={`${process.env.PUBLIC_URL}/${cat.link}`}
                  onClick={handleClose}
                >
                  {formatCategory(cat.category)}
                </Link>
              ))}
            </div>
          </div>

          {/* {search && !isSearching && hasSearchResults && (
            <p className={classes.resultsInfo}>
              We found <b>{totalProducts} products</b> for "<b>{search}</b>"
            </p>
          )} */}

          {isSearching ? (
            <div className={classes.loading}>
              <div
                style={{
                  width: 60,
                  height: 60,
                  border: "3px solid #f3f3f3",
                  borderTop: "3px solid #722257",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                }}
              />
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
          ) : search && searchResults.length === 0 ? (
            <div className={classes.noResults}>
              <img src="/assets/images/sunny/no_data.svg" alt="No results" />
              <p className={classes.noResultsText}>
                No products matching "{search}"
              </p>
            </div>
          ) : (
            <div className={classes.productsWrapper}>
              <SearchResultGrid
                title={
                  hasSearchResults
                    ? `Products (${totalProducts})`
                    : "Trending products"
                }
                onClick={handleClose}
                searchResults={displayProducts.slice(0, 4)}
              />
            </div>
          )}

          {search && (
            <Link
              className={classes.exploreLink}
              to={`${process.env.PUBLIC_URL}/jewellery?query=${search}`}
              onClick={handleClose}
            >
              {hasSearchResults ? (
                <>View All Results</>
              ) : (
                <>Explore our collections</>
              )}
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default SearchDrawer;
